<!-- <form
  class="form-horizontal"
  autocomplete="off"
  #enviarTokenForm="ngForm"
  (ngSubmit)="reenviarTokent()"
>
  <abp-modal-header
    [title]="'Recuperação de Senha'"
    (onCloseClick)="bsModalRef.hide()"
  ></abp-modal-header>
  <div class="modal-body">

    <div class="form-group row">
      <p class="col-md-12 col-form-label" for="cpf">
        Em instantes você receberá um token via SMS, informe-o nos campos abaixo.
      </p>
    </div>

    <div class="form-group row">
      <label class="col-md-6 col-form-label required" for="cpf">
        Informe o token
      </label>
      <code-input class="text" [isCodeHidden]="false"
          [codeLength]="6"
          [isPrevFocusableAfterClearing]="true"
          [initialFocusField]="0"
          (codeCompleted)="onCodeCompleted($event)">
      </code-input>
    </div>

  </div>
  <abp-modal-footer
  [cancelDisabled]="saving"
  [saveDisabled]="naoPodeReenviarToken"
  (onCancelClick)="bsModalRef.hide()"
  [saveLabel]="labelReenviarToken"
  >
  </abp-modal-footer>
</form> -->


<abp-modal-header
  [title]="'Recuperação de Senha'"
  (onCloseClick)="bsModalRef.hide()"
></abp-modal-header>

<div class="modal-body text-center">
  <p class="mb-2 font-weight-semibold">
    Enviamos um e-mail com as instruções para redefinir sua senha.
  </p>

  <p class="text-muted mb-0">
    Caso não encontre, verifique também a pasta de spam.
  </p>
</div>

<div class="modal-footer text-center">
  <button
    type="button"
    class="btn btn-blue-prodiis"
    (click)="bsModalRef.hide()"
  >
    Entendi
  </button>
</div>


